// Type de formation: Initiale (FI) ou Continue (FC)
export enum TypeFormation {
  INITIALE = 'INITIALE',
  CONTINUE = 'CONTINUE',
}

// Statut d'assignation aux groupes
export enum GroupAssignmentStatus {
  PENDING = 'PENDING',
  ASSIGNED = 'ASSIGNED',
}

// Groupe académique
export interface Groupe {
  id: string;
  tenantId: string;
  academicYearId: string;
  filiereId: string;
  campusId?: string | null;
  niveau: number;
  typeFormation: TypeFormation;
  name: string;
  suffix: string | null;
  maxStudents: number | null;
  isActive: boolean;
  sortOrder: number;
  studentCount?: number;
}

// Groupe avec nombre d'étudiants
export interface GroupeWithCounts extends Groupe {
  studentCount: number;
}

// Étudiant basique pour les listes
export interface StudentBasic {
  id: string;
  studentCode: string;
  firstName: string;
  lastName: string;
  niveauFormation: number | null;
  typeFormation: TypeFormation;
  groupAssignmentStatus?: GroupAssignmentStatus;
  codeFiliereInscrit?: string | null;
  photoUrl?: string | null;
}

// Comptage des étudiants par niveau
export interface StudentCountByNiveau {
  niveau: number;
  fiCount: number;
  fcCount: number;
  fiPending: number;
  fcPending: number;
  fiAssigned: number;
  fcAssigned: number;
}

// Résultat d'assignation
export interface AssignmentResult {
  success: boolean;
  assignedCount: number;
  groupDistribution: {
    groupId: string;
    groupName: string;
    count: number;
  }[];
}

// Ce qui dépend d'un groupe (affiché avant une suppression)
export interface GroupImpact {
  students: number;
  grades: number;
  attendance: number;
  scheduleEntries: number;
  rattrapages: number;
  finalizations: number;
}

// DTOs pour les requêtes API

export interface CreateGroupeDto {
  filiereId: string;
  niveau: number;
  typeFormation: TypeFormation;
  maxStudents?: number;
  groupCount?: number;
  campusId?: string;
}

export interface UpdateGroupeDto {
  name?: string;
  maxStudents?: number;
  isActive?: boolean;
}

export interface AssignStudentsDto {
  studentIds: string[];
}

export interface RandomAssignmentDto {
  typeFormation: TypeFormation;
}

export interface ChangeTypeFormationDto {
  typeFormation: TypeFormation;
}

export interface ReassignStudentDto {
  newGroupId: string;
}

// Labels pour l'affichage
export const TypeFormationLabels: Record<TypeFormation, string> = {
  [TypeFormation.INITIALE]: 'Formation Initiale',
  [TypeFormation.CONTINUE]: 'Formation Continue',
};

export const TypeFormationShortLabels: Record<TypeFormation, string> = {
  [TypeFormation.INITIALE]: 'FI',
  [TypeFormation.CONTINUE]: 'FC',
};

export const GroupAssignmentStatusLabels: Record<GroupAssignmentStatus, string> = {
  [GroupAssignmentStatus.PENDING]: 'En attente',
  [GroupAssignmentStatus.ASSIGNED]: 'Assigné',
};

// Helpers pour les noms de niveau
export const NiveauLabels: Record<number, string> = {
  1: '1ère Année',
  2: '2ème Année',
  3: '3ème Année',
  4: '4ème Année',
  5: '5ème Année',
};

export function getNiveauLabel(niveau: number): string {
  return NiveauLabels[niveau] || `${niveau}ème Année`;
}
